<template>
  <div class="content-430">
    <div class="row-upload">
      <UploadBtn class="upload" @on-success="handleUpload"></UploadBtn>
      <span v-show="file">{{ file.name }}</span>
    </div>
    <Button type="primary" @click="handleCheck">校验</Button>
  </div>
</template>

<script>


import UploadBtn from '@c/UploadBtn';
import axios from 'axios';
export default {
  components: {
    UploadBtn
  },
  data() {
    return {
      file: ''
    }
  },
  created() {

  },
  methods: {
    handleUpload(file) {
      this.file = file[0]

      console.log(this.file);
    },
    handleCheck() {
      if (!this.file) {
        this.$Message.warning('请选择文件');
      }
      // this.handleToUpload(this.file)
      this.handleToUpload1(this.file)
    },
    handleToUpload(ev) {
      return new Promise(async (resolve, reject) => {
        const file = ev;
        const formData = new FormData();

        formData.append('file', file);
        const token = localStorage.getItem('loginToken');
        this.source = axios.CancelToken.source();
        var configs = {
          // 上传文件 请求头要设置成下面这样
          headers: {
            token: token,
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          onUploadProgress: progressEvent => {

          },
          cancelToken: this.source.token
        };

        //   axios.post(`${process.env.VUE_APP_API_COURSE_URL}/course/import/downloadCourseClass?bureauId=676814433481129985`, formData, configs).then(res => {
        axios.post(`http://gwuat.gzhtedu.cn/course430/course/import/downloadCourseClass?bureauId=676814433481129985`, formData, configs).then(res => {
          var filename = `a.xls`
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, filename);
          } else {
            var a = document.createElement('a');
            document.body.appendChild(a)
            var url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = filename;
            a.target = '_blank'  // a标签增加target属性
            a.click();
            a.remove()  //移除a标签
            window.URL.revokeObjectURL(url);
          }
        }).catch(err => {
          if (err.message) {
            this.$Message.error(err.message);
          }
        }).finally(() => {


        });
      });
    },
    handleToUpload1(ev) {
      return new Promise(async (resolve, reject) => {
        const file = ev;
        const fd = new FormData()
        fd.append('file', file);
        fetch(`${process.env.VUE_APP_API_COURSE_URL}/course/import/downloadCourseClass?bureauId=676814433481129985`,
          {
            method: 'post',
            body: fd,

          }
        ).then(res => res.blob().then(blob => {
          var filename = `a.xls`
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, filename);
          } else {
            var a = document.createElement('a');
            document.body.appendChild(a)
            var url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = filename;
            a.target = '_blank'  // a标签增加target属性
            a.click();
            a.remove()  //移除a标签
            window.URL.revokeObjectURL(url);
          }
        }))
      });
    }
  }
}
</script>



<style lang="scss" scoped>
.content-430 {
  .row-upload {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
  }
}
</style>